import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ProfileView = () => {

  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    const navbar = document.querySelector(".navbar");

    const handleScroll = () => {
      const currentScroll = window.pageYOffset;

      if (!navbar) return;

      if (currentScroll <= 10) {
        navbar.style.transform = "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      } else {
        navbar.style.transform = "translateX(-50%) translateY(-130%)";
        navbar.style.opacity = "0";
      }
    };

    if (navbar) {
      navbar.style.position = "fixed";
      navbar.style.top = "15px";
      navbar.style.left = "50%";
      navbar.style.width = "90%";
      navbar.style.maxWidth = "1100px";
      navbar.style.transform = "translateX(-50%)";
      navbar.style.zIndex = "9999";
      navbar.style.transition = "all 0.35s ease";
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);

      if (navbar) {
        navbar.style.transform = "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      }
    };
  }, []);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (!storedUser) {
      navigate("/auth");
      return;
    }

    fetch("https://edunet.kmechengineering.com/root-engine1/api/profile?email=" + storedUser.email)
      .then(res => res.json())
      .then(data => {
        if (data.user) {
          setUser({
            ...data.user,
            picture: data.user.image
          });
        }
      });

  }, [navigate]);

  if (!user) return null;

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      const res = await fetch(
        "https://edunet.kmechengineering.com/root-engine1/api/profile",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          body: JSON.stringify(user),
        }
      );

      const result = await res.json();

      if (result.status) {

        const updated = {
          ...result.user,
          picture: result.user.image
        };

        localStorage.setItem("user", JSON.stringify(updated));
        setUser(updated);

        alert("Saved successfully!");
        setEditMode(false);
      }

    } catch {
      alert("Error saving");
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setUser({ ...user, picture: reader.result });
    };
    reader.readAsDataURL(file);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/auth");
  };

  return (
    <div style={styles.container}>

      <div style={styles.card}>

        {!editMode ? (
          <>
            <div style={styles.top}>
              <img
                src={`${user.picture}?t=${Date.now()}`}
                style={styles.avatar}
              />
              <div>
                <h2>{user.name}</h2>
                <p>{user.email}</p>
              </div>
            </div>

            {info("📱 Phone", user.phone)}
            {info("🏠 Address", user.address)}
            {info("🎓 Grade", user.grade)}
            {info("📚 Stream", user.stream)}
            {info("🏫 School", user.school)}
            {info("🎂 Age", user.age)}
            {info("📍 City", user.city)}
            {info("🌍 Country", user.country)}

            <div style={styles.btnRow}>
              <button style={styles.btnPrimary} onClick={() => setEditMode(true)}>
                Edit Profile
              </button>

              <button style={styles.backBtn} onClick={() => navigate(-1)}>
                Back
              </button>

              <button style={styles.logoutBtn} onClick={handleLogout}>
                Logout
              </button>
            </div>
          </>
        ) : (
          <>
            <h2>Edit Profile</h2>

            <input style={styles.input} name="name" value={user.name || ""} onChange={handleChange} />
            <input style={styles.input} name="phone" value={user.phone || ""} onChange={handleChange} />
            <input style={styles.input} name="address" value={user.address || ""} onChange={handleChange} />
            <input style={styles.input} name="grade" value={user.grade || ""} onChange={handleChange} />
            <input style={styles.input} name="stream" value={user.stream || ""} onChange={handleChange} />
            <input style={styles.input} name="school" value={user.school || ""} onChange={handleChange} />
            <input style={styles.input} name="age" value={user.age || ""} onChange={handleChange} />
            <input style={styles.input} name="city" value={user.city || ""} onChange={handleChange} />
            <input style={styles.input} name="country" value={user.country || ""} onChange={handleChange} />

            <input type="file" onChange={handleImageUpload} style={{ marginTop: "10px" }} />

            <div style={styles.btnRow}>
              <button style={styles.btnPrimary} onClick={handleSave}>Save</button>
              <button style={styles.btnSecondary} onClick={() => setEditMode(false)}>Cancel</button>
            </div>
          </>
        )}

      </div>
    </div>
  );
};

export default ProfileView;

/* styles */

const styles = {
  container: {
    background: "#0f172a",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px"
  },

  card: {
    background: "#1f2937",
    padding: "20px",
    borderRadius: "10px",
    color: "#fff",
    width: "100%",
    maxWidth: "500px"
  },

  top: {
    display: "flex",
    gap: "15px",
    marginBottom: "15px"
  },

  avatar: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    objectFit: "cover"
  },

  btnRow: {
    marginTop: "15px",
    display: "flex",
    gap: "10px"
  },

  btnPrimary: {
    background: "#2d89ff",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "8px"
  },

  btnSecondary: {
    background: "#444",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "8px"
  },

  backBtn: {
    background: "#10b981",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "8px"
  },

  logoutBtn: {
    background: "#ef4444",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer"
  },

  input: {
    width: "100%",
    padding: "10px",
    marginTop: "10px",
    borderRadius: "8px",
    border: "none"
  }
};

const info = (label, value) => (
  <div style={{
    display: "flex",
    justifyContent: "space-between",
    background: "#111827",
    padding: "10px",
    marginTop: "8px",
    borderRadius: "8px"
  }}>
    <b>{label}</b>
    <span>{value || "Not added"}</span>
  </div>
);